export default __webpack_public_path__ + "static/media/AccountingBot_Setup.1df26e11.zip";